import striptags from "striptags";

export function stripHtmlTags(text) {
  if (text == null) {
    return "";
  }
  const stripped = striptags(text);
  const el = document.createElement("textarea");
  el.innerHTML = stripped;
  return el.value.replace(/\u00A0/g, " ");
}

export function truncate(text, threshold = 100) {
  if (text) {
    if (text.length < threshold) {
      return text;
    }
    return text
      .split(" ")
      .slice(0, 25)
      .join(" ")
      .concat("...");
  }
}
